module.exports = __webpack_public_path__ + "img/andreas-zygmuniak.b2837fb9.jpg";